import request from "../utils/request";

// ─── 类型定义 ─────────────────────────────────────────────────────────────────

export type LogStatus = "success" | "failed";

export type UserRole = "CRA" | "CSM" | "Admin" | "Staff" | "Auditor" | "Manager";

export type OpType =
  | "login"
  | "logout"
  | "submitFeedback"
  | "translate"
  | "feedback"
  | "downloadSource"
  | "uploadPersonnelFiles"
  | "manageUser"
  | "manageStudy"
  | "manageAskSource"
  | "manageMvrSource"
  | "markFailedFiles"
  | "manageRecommendedQuestion"
  | "manageHealthMonitor"
  | "manageSecurityRecords"
  | "setFeedbackNote"
  | "manageSystemSettings";

export interface OperationLog {
  id: string;
  /** 北京时间 yyyy-MM-dd HH:mm:ss */
  time: string;
  user: string;
  userId?: string;
  role: UserRole;
  opType: OpType;
  detail: string;
  ip: string;
  status: LogStatus;
  params?: Record<string, string>;
}

export interface OperationLogFilters {
  opType?: OpType | "";
  role?: UserRole | "";
  status?: LogStatus | "";
  search?: string;
  page?: number;
  pageSize?: number;
}

export interface PagedResult<T> {
  data: T[];
  total: number;
  page: number;
  pageSize: number;
}

// ─── API 方法 ─────────────────────────────────────────────────────────────────

export async function getOperationLogs(
  filters: OperationLogFilters = {},
): Promise<PagedResult<OperationLog>> {
  const params: Record<string, string> = {};
  if (filters.opType) params.opType = filters.opType;
  if (filters.role) params.role = filters.role;
  if (filters.status) params.status = filters.status;
  if (filters.search?.trim()) params.search = filters.search.trim();
  if (filters.page) params.page = String(filters.page);
  if (filters.pageSize) params.pageSize = String(filters.pageSize);

  const res = await request.get<PagedResult<OperationLog>>("/project/operationlog/list", {
    params: Object.keys(params).length ? params : undefined,
  });
  return res.data ?? { data: [], total: 0, page: filters.page ?? 1, pageSize: filters.pageSize ?? 10 };
}
